<template>
  <thead
    v-if="computedColumns.length > 0"
    class="comp-list-header"
    :class="{ 'no-offset': noInteractionBar }"
  >
    <tr>
      <th></th>
      <th
        scope="col"
        v-for="(column, idx) in computedColumns"
        :key="`list-header-column-${idx}`"
        :data-column-id="column.id"
        :class="{ sort: column.id === isort.property }"
        @click="handleColumnClick(column)">
        <div>
          <span>{{ column.label }}</span>
          <div class="sort" v-if="column.sortable">
            <Icon
              name="sort"
              :class="{ ascending: sort.ascending }"
            />
          </div>
        </div>
      </th>
      <th></th>
    </tr>
  </thead>
</template>

<script>
  import Icon from '@/components/ui/Icon';

  export default {
    name: 'ListHeader',
    components: {
      Icon,
    },
    //---------------------------------------------------
    //
    //  Properties
    //
    //---------------------------------------------------
    props: {
      structure: {
        type: Object,
        default: () => {},
      },
      sort: {
        type: Object,
        default: () => ({
          property: null,
          ascending: true,
        }),
      },
      noInteractionBar: {
        type: Boolean,
        default: false,
      },
    },
    //---------------------------------------------------
    //
    //  Data model
    //
    //---------------------------------------------------
    data() {
      return {
        isort: this.sort || { property: null, ascending: false },
      };
    },
    //---------------------------------------------------
    //
    //  Computed Properties
    //
    //---------------------------------------------------
    computed: {
      computedColumns() {
        const out = [];
        const structure = this.structure;
        const keys = Object.keys(structure);
        keys.forEach((key) => {
          const item = structure[key];
          out.push({ id: key, label: item.label, sortable: item.sortable !== false });
        });
        return out;
      },
    },
    //---------------------------------------------------
    //
    //  Watch Properties
    //
    //---------------------------------------------------
    watch: {},
    //---------------------------------------------------
    //
    //  Filter Properties
    //
    //---------------------------------------------------
    // filters: {},
    //---------------------------------------------------
    //
    //  Validation Properties
    //
    //---------------------------------------------------
    // validations: {},
    //---------------------------------------------------
    //
    //  Vue Lifecycle
    //
    //---------------------------------------------------
    // beforeCreate() {},
    // created() {},
    // beforeMount() {},
    // render(h) { return h(); },
    // mounted() {},
    // beforeUpdate() {},
    // updated() {},
    // beforeDestroy() {},
    // destroyed() {},
    //---------------------------------------------------
    //
    //  Methods
    //
    //---------------------------------------------------
    methods: {
      //----------------------------------
      // Event Handlers
      //----------------------------------
      handleColumnClick(column) {
        if (column.sortable) {
          const id = column.id;
          const sort = this.isort;
          if (sort.property === id) {
            sort.ascending = !sort.ascending;
          }
          sort.property = id;
          this.isort = sort;
          this.$emit('update:sort', sort);
        }
      },
    },
  };
</script>

<style lang="scss">
@import '~scss/mixins';
@import '~scss/variables';

.comp-list-header {
  position: sticky;
  left: 0;
  top: 76px;
  width: 100%;
  background-color: #F2F2F2; // $color-black-alpha-05;
  z-index: 2;

  &.no-offset {
    top: -1px;
  }

  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    height: 1px;
    width: 100%;
    background-color: $color-black-alpha-20;
  }
  th {
    & > div {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      height: 42px;
      width: 100%;
      cursor: pointer;
      user-select: none;

      & > span {
        @include font-table-heading;
        color: $color-black-alpha-60;
        text-transform: uppercase;
        white-space: nowrap;
      }

      & > div {
        margin-left: 4px;
        width: 15px;
        height: 15px;
        svg {
          width: inherit;
          height: inherit;
          color: $color-black-alpha-40;
        }
      }
    }

    &:first-of-type {
      width: 20px;
    }
    &:last-of-type {
      width: 50px;
    }

    &.sort {
      & > div {
        span, svg {
          color: $color-black-alpha-80;
          path:first-of-type { color: $color-black-alpha-40; }
          path:last-of-type { color: currentColor; }
        }
        svg.ascending {
          path:first-of-type { color: currentColor; }
          path:last-of-type { color: $color-black-alpha-40; }
        }
      }
    }
  }
}
</style>
